import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/autoplay';
import img from '../images/MesratGigEconomy.jpeg'; 
import img2 from '../images/ReactJs.jpeg';
import img3 from '../images/PostmanApI.jpeg';
import database from '../images/database.svg';
import placehold from '../images/PostmanApI.jpeg';
const Certification = () => {

    return (
       
        <div id="certification" className="py-12 lg:my-28">
        <div>
          <section className="light:bg-[#ffeff5] dark:bg-gray-800 text-center lg:mt-12 lg:py-10">
            <div className="m-auto max-w-6xl p-4 md:p-12">
              <h1 className="text-[#b54a73] font-black text-2xl md:text-3xl lg:text-4xl mb-6">Certifications & Training</h1>
              <h2 className="text-gray-600 font-semibold text-lg md:text-xl lg:text-2xl mb-8">
                I hold several certifications and have undergone online training to strengthen my technical skills, including:
              </h2>
              <Swiper
                modules={[Autoplay, EffectFade]}
                autoplay={{ delay: 1500, disableOnInteraction: false }}
                effect="fade"
                fadeEffect={{ crossFade: true }}
                speed={1500}
                loop={true}
              >
                {/* First Slide */}
                <SwiperSlide>
                  <div className="flex flex-col items-center">
                    <img
                      alt="Mesrat Gig Economy"
                      className="w-64 h-64 rounded-lg shadow-lg object-cover transition-transform transform hover:scale-105 duration-500"
                      src={img}
                    />
                    <h3 className="mt-4 text-xl lg:text-2xl text-[#b54a73] font-black">Mesrat Gig Economy</h3>
                  </div>
                </SwiperSlide>
                {/* Second Slide */}
                <SwiperSlide>
                  <div className="flex flex-col items-center">
                    <img
                      alt="Great Learning ReactJs"
                      className="w-105 h-105 rounded-lg shadow-lg object-cover transition-transform transform hover:scale-105 duration-500"
                      src={img2}
                    />
                    <h3 className="mt-4 text-xl lg:text-2xl text-[#b54a73] font-black">
                      <a href="https://verify.mygreatlearning.com/verify/EQIUZNRC" target="_blank" rel="noopener noreferrer">
                       ReactJs certification  👉Link
                      </a>
                    </h3>
                  </div>
                </SwiperSlide>
                {/* Third Slide */}
                <SwiperSlide>
                  <div className="flex flex-col items-center">
                    <img
                      alt="Postman API"
                      className="w-105 h-105 rounded-lg shadow-lg object-cover transition-transform transform hover:scale-105 duration-500"
                      src={img3}
                    />
                    <h3 className="mt-4 text-xl lg:text-2xl text-[#b54a73] font-black">
                      <a
                        href="https://api.badgr.io/public/assertions/qxRAxpm2RnKJybntSsvvOQ?identity__email=hilinamulugeta1557@gmail.com"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Postman API certification 👉Link
                      </a>
                    </h3>
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
          </section>
        </div>
      </div>
      
      
    );
    
}

export default Certification;